import * as React from "react";
import {
  Configure,
  connectStateResults,
  Hits,
  Index,
} from "react-instantsearch-dom";
import { indexName } from "../index_name";
import { IndexProps } from "../index_props";
import { SearchIndex } from "../types";

type ProductHitProps = {
  hit: SearchIndex.Product;
};

const ProductHit = ({ hit: product }: ProductHitProps): JSX.Element => (
  <a href={product.link_path}>
    <div className={"product-image-container"}>
      <img src={product.search_image_url} alt={product.full_name} />
    </div>
    <div className={"product-properties-container"}>
      {product.full_name}
      {product.stored > 0 ? (
        <div className={"availability"}>
          <img src="https://cdn.sporilek.cz/icons/stored.png" />
          <span>Skladem</span>
        </div>
      ) : (
        <div className={"availability"}>
          <span className={"unavailable"}>Momentálně nedostupné</span>
        </div>
      )}
    </div>
  </a>
);

const ProductResults = connectStateResults(
  ({ searchResults }): JSX.Element | null => {
    if (searchResults?.nbHits == 0) return null;

    return (
      <>
        <h4>Produkty</h4>
        <Configure hitsPerPage={5} />
        <Hits hitComponent={ProductHit} />
      </>
    );
  }
);

export const ProductIndex = ({ environment }: IndexProps): JSX.Element => (
  <Index indexName={indexName(environment, "Sporilek_Product")}>
    <ProductResults />
  </Index>
);
